module.exports = __webpack_public_path__ + "static/media/foto3.db3e935a.png";